import React, { useContext } from 'react'
import { StyledTableHead, StyledHeaderRow, StyledHeaderCell } from './StyledDataTable'
import SearchInput from 'components/SearchInput'
import get from 'lodash/get'
import { DataTableContext } from './DataTable'

const TableHeader = ({ noData }) => {
	const { headerGroups, additionalWidth, withSearch } = useContext(DataTableContext)
	const { canFilter, setFilter } = get(headerGroups, '0.headers.0', {})

	return(
		<StyledTableHead>
			{headerGroups.map((headerGroup) => (
				<StyledHeaderRow {...headerGroup.getHeaderGroupProps()}>
					{headerGroup.headers.map((column, i) => (
						<StyledHeaderCell
							canSort={column.canSort}
							isSortedDesc={column.isSortedDesc}
							isSorted={column.isSorted}
							{...column.getHeaderProps(column.getSortByToggleProps())}
							className={column.className}
							style={{ ...column.headerStyle, minWidth: `${(column.width || 100) + additionalWidth}px` }}
							key={i}
						>
							{column.render('Header')}
						</StyledHeaderCell>
					))}
				</StyledHeaderRow>
			))}
			{/*!noData && */withSearch && canFilter && <SearchInput onSearch={setFilter}/>}
		</StyledTableHead>
	)
}

export default TableHeader
